var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"template-padding",attrs:{"fill-height":"","column":""}},[_vm._l((_vm.items),function(item,itemIndex){return _c('div',{key:itemIndex},[(item.type == 'banner' && itemIndex == 0)?[_c('div',{staticClass:"container",class:_vm.outerContainer},[_c('v-flex',{staticClass:"text-left"},[_c('div',{staticClass:"montserrat"},[_c('div',{staticClass:"font-weight-bold h4 mb-3",staticStyle:{"color":"#f2482f"},attrs:{"contenteditable":_vm.editableContent},domProps:{"innerHTML":_vm._s(item.heading)},on:{"focusout":function($event){return _vm.editableData('banner', { element: 'heading' })}}}),_c('div',{staticClass:"font-weight-bold h4 mb-3",staticStyle:{"color":"#131e56"},attrs:{"contenteditable":_vm.editableContent},domProps:{"innerHTML":_vm._s(item.subtitle)},on:{"focusout":function($event){return _vm.editableData('banner', { element: 'subtitle' })}}})])]),(_vm.pageType == 'Canvas')?_c('RowControls',{attrs:{"rowIndex":itemIndex}}):_vm._e()],1)]:_vm._e(),(item.type == 'grids')?[_c('Grid2',{attrs:{"item":item,"index":itemIndex,"styles":{
					text: 'body montserrat',
					image: {
						contain: true,
						wrapper: '',
						class: '',
						height: 'auto',
						width: 'auto',
						maxWidth: '100%',
						maxHeight: '',
						custom: {
							margin: '0 auto'
						}
					},
					heading1: {
						wrapper: '',
						classMobile: 'mb-5 montserrat font-weight-bold h5',
						classLarge: 'mb-5 montserrat font-weight-bold h5',
						after: '',
						guideWrapper: 'mb-5',
						guideClass: 'ml-5'
					},
					heading2: {
						wrapper: 'mt-5 mb-5 justify-center',
						classMobile: 'body montserrat grey--text',
						classLarge: 'body montserrat grey--text',
						after: '',
						guideWrapper: 'mt-5 mb-5',
						guideClass: 'ml-5'
					},
					textcard: {
						outlined: false,
						elevation: 0,
						card: 'bpp-card text-center pa-5 d-flex align-center justify-center',
						text: 'h5 montserrat-bold mb-5',
						subtitle: 'small-text poppins text-left mt-5'
					},
					imagecard: {
						doubleCard: false,
						elevation: 0,
						outlined: false,
						card: 'travel-english pa-5',
						imagePosition: 'bottom',
						image: {
							width: '',
							height: ''
						},
						text: 'text-left montserrat font-weight-bold body dark-blue',
						subtitle: ''
					},
					dialog: {
						elevation: 0,
						cardClass: 'py-5 px-5 mb-5',
						cardColor: '#F4F5F7',
						innerCard: '',
						dialogTitle: '',
						dialogName: 'montserrat body text-left mt-5 mr-3 responsive-text',
						textWrapper: 'montserrat body text-left responsive-text',
						custom: {
							text: '',
							textClass: 'mt-5'
						}
					}
				}}})]:_vm._e()],2)}),_c('ImageUploader'),_c('span',{attrs:{"id":"controls"}},[_c('i',{staticClass:"bx bxs-x-square",attrs:{"id":"close"},on:{"click":_vm.hideControls}}),_c('i',{staticClass:"bx bxs-circle",attrs:{"id":"selection-blue"},on:{"click":function($event){return _vm.changeColor('blue')}}}),_c('i',{staticClass:"bx bxs-circle",attrs:{"id":"selection-yellow"},on:{"click":function($event){return _vm.changeColor('yellow')}}}),_c('i',{staticClass:"bx bxs-circle",attrs:{"id":"selection-green"},on:{"click":function($event){return _vm.changeColor('green')}}}),_c('i',{staticClass:"bx bxs-circle",attrs:{"id":"selection-red"},on:{"click":function($event){return _vm.changeColor('red')}}}),_c('i',{staticClass:"bx bxs-note",attrs:{"id":"add-note"},on:{"click":_vm.openModal}}),_c('i',{staticClass:"bx bxs-trash-alt",attrs:{"id":"delete"},on:{"click":_vm.deleteHighlight}})]),_c('v-dialog',{attrs:{"max-width":"400","persistent":false},model:{value:(_vm.notes.modal),callback:function ($$v) {_vm.$set(_vm.notes, "modal", $$v)},expression:"notes.modal"}},[_c('v-card',{staticClass:"pa-5 pt-10"},[_c('v-textarea',{attrs:{"outlined":"","placeholder":"Add a note."},model:{value:(_vm.notes.data),callback:function ($$v) {_vm.$set(_vm.notes, "data", $$v)},expression:"notes.data"}}),_c('v-row',{attrs:{"justify":"center"}},[_c('v-btn',{attrs:{"small":"","dense":"","color":"primary"},on:{"click":_vm.saveNote}},[_vm._v("Save Note")])],1)],1)],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }